import type {
  GetComponentStyle,
  StylingPageLinkComponentProps,
} from '@vtaits/react-paginator';

import type {
  PaginatorPayload,
} from '../types';

export const pageLinkStyle: GetComponentStyle<
StylingPageLinkComponentProps<PaginatorPayload>
> = (baseCSS, {
  isCurrent,

  theme: {
    colors,
    fonts,
  },
}) => ({
  ...fonts.CAPTION,
  display: 'inline-block',
  verticalAlign: 'bottom',
  minWidth: 32,
  textAlign: 'center',
  textDecoration: 'none',
  padding: 7,
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: isCurrent ? colors.ACTION_INACTIVE : colors.NEUTRAL_INACTIVE,
  cursor: isCurrent ? 'default' : 'pointer',
  outline: 'none',
  backgroundColor: isCurrent ? colors.ACTION_BACKGROUND : colors.NEUTRAL_WHITE,
  color: isCurrent ? colors.NEUTRAL_DEFAULT : colors.ACTION_DEFAULT,
  position: isCurrent ? 'relative' : undefined,

  ':first-child': {
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
    marginLeft: 0,
  },

  ':last-child': {
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
  },

  ':hover': isCurrent ? undefined : {
    position: 'relative',
    zIndex: 1,
    color: colors.ACTION_HOVER,
    borderColor: colors.ACTION_HOVER,
    backgroundColor: colors.ACTION_BACKGROUND,
  },

  ':active': isCurrent ? undefined : {
    position: 'relative',
    zIndex: 1,
    color: colors.ACTION_PRESSED,
    borderColor: colors.ACTION_PRESSED,
    backgroundColor: colors.ACTION_BACKGROUND,
  },

  '& + &': {
    marginLeft: -1,
  },
});
